import SmartMinutesService from "../../services/SmartMinutesService";
import {
  applySmartMinutesJobResult,
  syncVoiceSamplesAndSuggestions
} from "./ataDraftStore";

/**
 * Aplica resultado do job e dispara sync de amostras/sugestão de voz.
 */
export function applySmartMinutesJobWithVoice(job) {
  const updated = applySmartMinutesJobResult(job);
  if (updated && updated.meetingId) {
    Promise.resolve(
      syncVoiceSamplesAndSuggestions(updated, SmartMinutesService)
    ).catch(() => {
      // Sync de voz pós-job é best-effort (demo/lab).
    });
  }
  return updated;
}
